<template>
  <div>
    <span
      :class="['badge', 'text-white', statuses[status].class]"
      style="line-height:1.2"
    >{{ statuses[status].text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status: {}
  },

  data : () => ({
    statuses: {
        o: {
          text: "Aberto",
          class: "badge-primary"
        },

        p: {
          text: "Pago",
          class: "badge-success"
        },

        c: {
          text: "Cancelado",
          class: "badge-danger"
        },

        r: {
          text: "Renegociado",
          class: "badge-warning"
        }
      }
  })
};
</script>

<style>
</style>